'use client'

import Footer from '@/components/home/Footer'
import { useIsMobile } from '@/hooks/use-mobile'

export default function FooterWrapper() {
  const isMobile = useIsMobile()
  return <Footer isMobile={isMobile} />
}
